import React, { useState } from "react";
import { getOenInfo } from "../QueryHelper";

const regex = new RegExp('^[0-9]{9}$');

export function FileSearcher() {
  const [oen, setOen] = useState("");
  const [fileDetails, setFileDetails] = useState("");
  const [error, setError] = useState("");

  return (
    <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" id="form2">
      <label for="oen" class="form-label inline-block mb-2 text-gray-700">
        Search for a Validation Code based on OEN
      </label>
      <input
        class="shadow appearance-none border rounded mb-5 w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        id="oen"
        type="text"
        maxLength={9}
        placeholder="123456789"
        onChange={(e) => {
          setOen(e.target.value);
        }}
      />
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        type="button"
        form="form2"
        onClick={async (e) => {
          setError("");
          if (oen) {
            if(!regex.test(oen)) {
              setError("Incorrect OEN format. Must be exactly 9 digits.");
              return;
            }
            const result = await getOenInfo({ oen, setError });
            setFileDetails(result);
          }
        }}
      >
        Search OEN
      </button>
      {fileDetails ? (
        <div className="mt-4">
          <p>OEN: {fileDetails.oen}</p>
          <p>Validation Code: {fileDetails.uuidValue}</p>
          <p>Print Date: {fileDetails.printDate}</p>
        </div>
      ) : (
        error && <p className="mt-4 text-red-600	">{error}</p>
      )}
    </form>
  );
}
